<h1>03-29-2022</h1>
<ul>
  <li>Receipts by Member Report</li>
  <li>Add Campaign Order Infomration</li>
</ul>
<h1>04-02-2022</h1>
<ul>
  <li>Add Sales Campaign Setup</li>
  <li>Add Sales Campaign List</li>
</ul>

<h1>04-23-2022</h1>
<ul>
  <li>Add Campaign Setup</li>
  <li>Add Campaign Order Infomration</li>
  <li>Add Read Me Page</li>
</ul>
<h1>05-03-2022</h1>
<ul>
  <li>Add CashApp Import</li>
  <li>Add Paypal Import</li>
</ul>
<h1>05-04-2022</h1>
<ul>
  <li>Fix Complete Transaction Bug</li>
</ul>
<h1>05-13-2022</h1>
<ul>
  <li>Add Other Import</li>
</ul>
<h1>07-15-2024</h1>
<ul>
  <li>duesPlus deposits</li>
</ul>
<h1>08-05-2024</h1>
<ul>
  <li>Add ability to Split Transactions</li>
  <li>Report balance corrections for Treasurer's Report</li>
</ul>
